export const MAX_LIST_NAME_LENGTH = 75;

// Error Types which correspond to classes for styling
export const MESSAGE_TYPE_SUCCESS = 'success';
export const MESSAGE_TYPE_INFO = 'info';
export const MESSAGE_TYPE_WARNING = 'warning';
export const MESSAGE_TYPE_DANGER = 'danger';
export const MESSAGE_TYPE_ERROR = 'danger';

// Launch Darkly
export const LD_NON_PROD_KEY = '5a6a55245dc0730a17dbd39e';
export const LD_PROD_KEY = '5a6a54ded2dfe40a43a34a83';

//Drag Drop Status
export const EMPTY = 'EMPTY';
export const SUCCESS = 'SUCCESS';
export const WARNING = 'WARNING';
export const LOADING = 'LOADING';
export const SUCCESS_PARTIALLY = 'SUCCESS_PARTIALLY';
